/* ============================================================================
 * WEBWINKELKEUR / VALUED WIDGETS  -  gedrag voor alle plaatsingen
 * ----------------------------------------------------------------------------
 * Het widget rendert zichzelf in een shadow DOM. Thema-CSS komt daar niet bij,
 * dus alles wat binnenin moet gebeuren staat hier.
 *
 * Elke plaatsing beschrijft ZICHZELF met data-attributen op de <valued-widget>:
 *
 *   data-wwk-stars="28"              sterren op 28px
 *   data-wwk-hide-count              verberg "Gebaseerd op X reviews"
 *   data-wwk-label="webshopreviews"  vervang het woord "reviews" hierdoor
 *   data-wwk-full-width              balk vult de volle breedte van de wrapper
 *
 * Een nieuwe plaatsing toevoegen = attributen zetten in snippets/wwk-bar.liquid.
 * Dit bestand hoeft daarvoor NIET aangepast te worden.
 *
 * Waarom de polling: het widget vult zijn shadow DOM pas na laden, en soms
 * opnieuw. We kijken 10 seconden lang elke 100ms of er nog iets te doen is.
 * Alle bewerkingen zijn idempotent, dus herhalen is veilig.
 * ========================================================================== */
(() => {
  const STOP_AFTER_MS = 10000;
  const POLL_MS = 100;
  const stopTime = Date.now() + STOP_AFTER_MS;

  const applyTo = (widget) => {
    const root = widget.shadowRoot;
    if (!root) return;
    const cfg = widget.dataset;

    /* --- Sterformaat ------------------------------------------------------ */
    if (cfg.wwkStars) {
      const rating = root.querySelector('.widget-rating');
      if (rating) {
        const size = cfg.wwkStars + 'px';
        root.host.style.setProperty('--star-size', size);
        const wrapper = rating.querySelector('.stars-wrapper');
        if (wrapper) wrapper.style.setProperty('--star-size', size, 'important');
      }
    }

    /* --- Aantal reviews verbergen ----------------------------------------- */
    if (widget.hasAttribute('data-wwk-hide-count')) {
      root.querySelectorAll('.reviews').forEach((el) => {
        el.style.display = 'none';
      });
    }

    /* --- Scope-label: maak duidelijk dat dit de SHOP-score is -------------- */
    else if (cfg.wwkLabel) {
      root.querySelectorAll('.reviews').forEach((el) => {
        if (!el.textContent.includes(cfg.wwkLabel)) {
          el.textContent = el.textContent.replace('reviews', cfg.wwkLabel);
        }
      });
    }

    /* --- Volle breedte ----------------------------------------------------- */
    if (widget.hasAttribute('data-wwk-full-width')) {
      const outer = root.querySelector('div');
      if (outer) {
        outer.style.setProperty('width', '100%', 'important');
        outer.style.setProperty('box-sizing', 'border-box', 'important');
      }
    }
  };

  const tick = () => {
    document.querySelectorAll('valued-widget').forEach(applyTo);
    if (Date.now() < stopTime) setTimeout(tick, POLL_MS);
  };

  tick();

  /* ==========================================================================
   * TIK-VANGER (mobiel)  -  aug 2026
   * --------------------------------------------------------------------------
   * Op desktop opent EEN klik op de balk meteen de volledige reviewlijst
   * (een overlay op body-niveau). Op touch deed WebwinkelKeur iets anders:
   * eerst een klein paneeltje (.wwk-sidebar-popup) in hun eigen shadow DOM.
   * Dat paneel was zichtbaar maar niet aantikbaar - het zit in de stacking
   * context van de <valued-widget> (z-index 2) en Dawn's <media-gallery>
   * staat ook op 2 maar komt later in de DOM, dus die ving elke tik op en
   * opende de foto-lightbox. Zie de uitleg in assets/wwk.css.
   *
   * Daarom: het widget staat op mobiel op pointer-events: none (in wwk.css),
   * zodat WebwinkelKeur's touch-afhandeling nooit een tik ziet. De
   * onzichtbare .wwk-bar__tap knop eroverheen doet in plaats daarvan een
   * PROGRAMMATISCHE klik op het widget binnenin - dat is het pad dat op
   * desktop wel meteen de reviewlijst opent.
   *
   * pointer-events blokkeert alleen echte muis/vinger-invoer, geen .click().
   * Geen recursie: de binnenste klik komt bovendrijven met de <valued-widget>
   * als target, niet de knop, dus de listener hieronder negeert hem.
   * ======================================================================== */
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || !target.closest) return;

    const tap = target.closest('.wwk-bar__tap');
    if (!tap) return;

    event.preventDefault();

    const bar = tap.closest('.wwk-bar');
    const widget = bar && bar.querySelector('valued-widget');
    const inner = widget && widget.shadowRoot && widget.shadowRoot.querySelector('.widget');

    if (inner) inner.click();
  });
})();
